import { COVERAGE_CODE } from "@/constants";

export const getPlanCoverageTypeName = (value: COVERAGE_CODE) => {
  switch (value) {
    case COVERAGE_CODE.MEDICAL:
      return "Medical & Pharmacy";
    case COVERAGE_CODE.DENTAL:
      return "Dental";
    case COVERAGE_CODE.VISION:
      return "Vision";
    case COVERAGE_CODE.ORTHODONTIA:
      return "Orthodontia";
    default:
      return "Medical & Pharmacy";
  }
};
